// @ts-nocheck


import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import qs from 'query-string';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';

import { maintenanceOperationPriceApi } from '../../lib/api';
import {
  formatDateTimeToString,
  getListInitialState } from
'./../../lib/helpers';





import { Popconfirm, Icon } from '../../components/ui';
import Table from '../../components/ui/Table';
import { Header, Section } from '../../components/layout';
import { notificationLoading } from './../../components/Notifications';


import Filter from './components/Filter';

import { withUserAccess } from './../withUserAccess';
import canAddMaintenanceOperationPriceAccess from './accessRight';
import { workHourPriceTypes } from '../../lib/enum';










export class MaintenanceOperationPriceList extends React.Component


{
  state = {
    ...getListInitialState(),
    filter: {}
  };

  columns = [
  {
    title: 'Филиал',
    dataIndex: 'orgUnitName'
  },
  {
    title: 'Стоимость н/ч',
    dataIndex: 'workingHourCost'
  },
  {
    title: 'Дата начала',
    dataIndex: 'startDate',
    render: (startDate) =>
    `${formatDateTimeToString(startDate, 'DD.MM.YYYY')}`
  },
  {
    title: 'Дата окончания',
    dataIndex: 'endDate',
    render: (endDate) =>
    `${formatDateTimeToString(endDate, 'DD.MM.YYYY')}`
  },
  {
    title: 'Вид нормо-часа',
    dataIndex: 'workingHourPriceType',
    render: (workingHourPriceType) =>
    workHourPriceTypes[workingHourPriceType]
  }];


  canAdd = () =>
  this.props.userAccess.some((access) =>
  canAddMaintenanceOperationPriceAccess.includes(access)
  );

  componentDidMount = async () => {
    const { page, ...filter } = qs.parse(window.location.search);
    if (this.canAdd()) {
      this.columns.push({
        stopPropagation: true,
        width: 20,
        dataIndex: 'id',
        render: (id) =>
        <Popconfirm
          title="Вы уверены, что хотите удалить запись?"
          onConfirm={async () => this.deleteMaintenanceOperationPrice(id)}>

            <Icon type="x" />
          </Popconfirm>

      });
    }
    this.setState(
      {
        filter: { ...filter },
        page
      },
      () => this.fetchMaintenanceOperationPrice(page)
    );
  };

  deleteMaintenanceOperationPrice = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await maintenanceOperationPriceApi.deleteMaintenanceOperationPrice(id);
      await this.fetchMaintenanceOperationPrice(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  fetchMaintenanceOperationPrice = async (page) => {
    const { filter } = this.state;
    this.setState({ loading: true });
    const data =
    await maintenanceOperationPriceApi.fetchMaintenanceOperationPrice({
      ...filter,
      page
    });
    this.setState({ ...data, page, loading: false });
  };

  applyFilter = (filter) =>
  this.setState({ filter }, () =>
  this.fetchMaintenanceOperationPrice(this.state.page)
  );

  cleanFilter = () =>
  this.setState({ filter: {} }, () =>
  this.fetchMaintenanceOperationPrice(this.state.page)
  );

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filter } = this.state;
    const canAdd = this.canAdd();
    return (
      <>
        <Header
          left={<h1>Прейскурант стоимости нормо-часа</h1>}
          right={
          canAdd &&
          <Button
            type="primary"
            onClick={() =>
            navigate('/admin/maintenance-operation-price/new')
            }>

                Создать
              </Button>

          } />

        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            columns={this.columns}
            data={data}
            fetch={this.fetchMaintenanceOperationPrice}
            onRow={(row) => ({
              onClick: () =>
              canAdd ?
              navigate(
                `/admin/maintenance-operation-price/${row.id}/edit`
              ) :
              navigate(`/admin/maintenance-operation-price/${row.id}`)
            })}
            loading={loading}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }} />

        </Section>
      </>);

  }
}

export default withUserAccess(MaintenanceOperationPriceList);
